import ServiceError from '#services/ServiceError';

const makeHandler = (controller, {
  transformError = null,
  defaultError = 'Generic error',
}) => async (...props) => {
  try {
    return await controller(...props);
  } catch (err) {
    throw new ServiceError(transformError
      ? transformError(err, defaultError) || defaultError
      : defaultError);
  }
};

export default makeHandler;
